import { atom, atomFamily } from "recoil";

import { KHeaderWidget } from "../../../models/configuration/components/kHeaderWidget";
import { KHeaderWidgetComponent, KHeaderWidgetComponentContext } from "./models";

export const kHeaderWidgetBurgerOpenState = atomFamily<boolean, KHeaderWidget["id"]>({
  key: "KHeaderWidgetBurgerOpenState",
  default: false,
});

export const kHeaderWidgetComponentsAtom = atomFamily<
  KHeaderWidgetComponent[],
  { widgetId: KHeaderWidget["id"]; context: KHeaderWidgetComponentContext }
>({
  key: "KHeaderWidgetComponentsAtom",
  default: [],
});

export const kHeaderWidgetAllBurgerOpentState = atom<boolean>({
  key: "kHeaderWidgetAllBurgerOpentState",
  default: false,
});
